import { Box, useTheme } from '@mui/material';
import { timeFrameBarOptions } from './style';
import { TimeBoxOption } from './components/time-box-option';
import { SelectedBoxType } from './types';
import { TimeOptionType } from '../../types';
import { OneDayRangeIcon } from 'src/assets/icons/OneDayRangeIcon';
import { OneMonthRangeIcon } from 'src/assets/icons/OneMonthRangeIcon';
import { SenvenDaysRangeIcon } from 'src/assets/icons/SenvenDaysRangeIcon';

type Props = {
  onSelectTimestampHandler?: (timeOption: TimeOptionType) => void;
  onTemporarySelectTabletTimeOption?: (timeOption: TimeOptionType) => void;
  isTablet?: boolean;
  selectedBox?: SelectedBoxType;
  onSelectBoxHandler?: (value: SelectedBoxType) => void;
  temporarySelectedTabletTimeOption?: TimeOptionType;
  onResetZoomHandler?: () => void;
  onSelectTemporaryTimestampHandler?: (timeOption: TimeOptionType) => void;
};

type TimeOption = {
  title: Exclude<TimeOptionType, 'custom'>;
  Icon: React.ComponentType<{ fill: string }>;
};

const TIME_OPTIONS: TimeOption[] = [
  { title: '5m', Icon: OneDayRangeIcon },
  { title: '1h', Icon: OneDayRangeIcon },
  { title: '3h', Icon: OneDayRangeIcon },
  { title: '6h', Icon: OneDayRangeIcon },
  { title: '1d', Icon: OneDayRangeIcon },
  { title: '7d', Icon: SenvenDaysRangeIcon },
  { title: '30d', Icon: OneMonthRangeIcon },
];

export const TimeFrameBarOptions = ({
  onSelectTimestampHandler,
  onTemporarySelectTabletTimeOption,
  isTablet,
  selectedBox,
  onSelectBoxHandler,
  temporarySelectedTabletTimeOption,
  onResetZoomHandler,
  onSelectTemporaryTimestampHandler,
}: Props) => {
  const theme = useTheme();
  const greyColor = theme.palette.grey[600];
  const mainColor = theme.palette.primary.main;

  return (
    <Box sx={timeFrameBarOptions}>
      {TIME_OPTIONS.map(({ title, Icon }) => (
        <TimeBoxOption
          key={title}
          selectedBox={selectedBox}
          title={title}
          icon={
            <Icon
              fill={
                selectedBox === title || temporarySelectedTabletTimeOption === title
                  ? mainColor
                  : greyColor
              }
            />
          }
          onSelectBoxHandler={onSelectBoxHandler}
          onSelectTimestampHandler={onSelectTimestampHandler}
          onTemporarySelectTabletTimeOption={onTemporarySelectTabletTimeOption}
          temporarySelectedTabletTimeOption={temporarySelectedTabletTimeOption}
          isTablet={isTablet}
          onResetZoomHandler={onResetZoomHandler}
          onSelectTemporaryTimestampHandler={onSelectTemporaryTimestampHandler}
        />
      ))}
    </Box>
  );
};
